import { render } from "./HiddenField.vue?vue&type=template&id=58917f48"
import script from "./HiddenField.vue?vue&type=script&lang=js"
export * from "./HiddenField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/administrator/Sites/HengFuTong/extends/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HiddenField.vue"]])

export default __exports__